import React, { useState } from "react";

const Tooltip = ({ content, children, position = "top" }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 transform -translate-x-1/2 mt-2",
    left: "right-full top-1/2 transform -translate-y-1/2 mr-2",
    right: "left-full top-1/2 transform -translate-y-1/2 ml-2",
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="inline-block"
      >
        {children}
      </div>
      {isVisible && (
        <div
          className={`absolute z-50 px-3 py-2 text-sm text-white bg-gray-900 rounded-md shadow-lg whitespace-nowrap ${positionClasses[position]}`}
        >
          {content}
          <div
            className={`absolute w-0 h-0 border-transparent border-solid ${
              position === "top"
                ? "border-t-gray-900 border-t-4 top-full left-1/2 -ml-2"
                : ""
            } ${
              position === "bottom"
                ? "border-b-gray-900 border-b-4 bottom-full left-1/2 -ml-2"
                : ""
            } ${
              position === "left"
                ? "border-l-gray-900 border-l-4 left-full top-1/2 -mt-2"
                : ""
            } ${
              position === "right"
                ? "border-r-gray-900 border-r-4 right-full top-1/2 -mt-2"
                : ""
            }`}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
